
import * as vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: {
    review: {
      type: [Array, Object],
    },
  },

  methods: {
    closeReview() {
      this.$emit("close-review-modal");
    },
  },
};
